import { render, staticRenderFns } from "./AppPrimaryButton.vue?vue&type=template&id=aa89b3c6&"
import script from "./AppPrimaryButton.vue?vue&type=script&lang=js&"
export * from "./AppPrimaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports